import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Animations, rotate } from 'app/animations';
import { ViewportService } from 'app/core/services/viewport.service';
import { Theme } from 'app/domain/theme.model';
import { ViewPort } from 'app/domain/view-port.model';
import { ImageAlternativeType, Picture } from 'ngx-web-api';
import { SpecialtyHalfs } from 'ngx-web-api/lib/models/menu/specialty-halfs.model';
import { Observable } from 'rxjs';

@Component({
  selector: 'fts-specialty-half',
  templateUrl: './specialty-half.component.html',
  styleUrls: ['./specialty-half.component.scss'],
  animations: [Animations.expanded, rotate('90deg', '100ms')],
})
export class SecialtyHalfComponent implements OnInit {
  @Input()
  half: SpecialtyHalfs;
  @Input()
  selectedHalf: SpecialtyHalfs;
  @Input()
  showSpecialtyHalfDetails = false;
  @Input()
  theme: Theme;
  public viewPort$: Observable<ViewPort>;

  @Output()
  halfClicked = new EventEmitter<SpecialtyHalfs>();

  picture: Picture;

  constructor(private viewPortService: ViewportService) {
    this.viewPort$ = this.viewPortService.viewport$;
  }

  ngOnInit(): void {
    this.picture = this.half.pictures?.find(p => p.type === ImageAlternativeType.ORIGINAL);
  }

  selectHalf() {
    this.halfClicked.emit(this.half);
  }
}
